import ratingList, { ratingBgColors } from "./rating"
import { Done, Notifications, NotificationsNone } from "@mui/icons-material"

const prosodies = [
    { id: "LOW", name: "ביצוע נמוך", borderColor: ratingList[4], bg: ratingBgColors[4], icon: NotificationsNone },
    { id: "MEDIUM", name: "ביצוע בינוני", borderColor: ratingList[2], bg: ratingBgColors[2], icon: NotificationsNone },
    { id: "HIGH", name: "ביצוע גבוה", borderColor: ratingList[1], bg: ratingBgColors[1], icon: Done }
]

export default prosodies